<ng-scrollbar>
  <cdk-virtual-scroll-viewport itemSize="82" minBufferPx="820" maxBufferPx="1640" scrollViewport>
    <div
      *cdkVirtualFor="let option of options; let i = index;"
      [ngClass]="option.classList"
    >
      <div class="campaign-option__container">
        <div class="campaign-option__index">{{i+1}}</div>
        <img class="campaign-option__image--playlist" [src]="getImageUrl(option.data)" />
        <div class="campaign-option__info">
          <div class="campaign-option__name campaign-option__name--playlist">{{ option.data.name }}</div>
          <div
            *ngIf="isNotAuction(campaign)"
            class="campaign-option__amount campaign-option__amount--playlist"
          >{{ option.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
        </div>
        <div class="campaign-option__actions">
          <button
            class="btn btn--paybee btn--success btn--playlist btn--md"
            [ngClass]="{'btn--live': option.isLive}"
            (click)="onPresent(campaign.id, option, false)"
            [disabled]="option.isDisabled"
          >{{ option.isLive ? 'Live': 'Present' }}</button>
        </div>
      </div>
      <div class="mt-3 widget__separator"></div>
    </div>
  </cdk-virtual-scroll-viewport>
</ng-scrollbar>
